export default {
	ENABLED: "enabled",
	DISABLED: "disabled",
}
